var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"loading":_vm.loading,"expanded":_vm.expanded,"icon-left":"fas fa-edit","label":_vm.hideText ? '' : String().capitalize(String(_vm.$t('buttons.edit'))),"type":"is-dark","inverted":true,"tag":_vm.tag,"to":_vm.to},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }